<template>
  <PageTemplate>
    <div class="row">
      <div class="col-md-6 ">
        <h1>Profile</h1>
      </div>
      <div class="col-md-6">
        <v-button-group is-right>
          <v-button
            v-if="isUserHasTARole()"
            size="xl"
            :disabled="disableMarkProfileUptodate"
            has-min-width
            @click="markProfileUptodate"
          >
            Mark Profile is up to date
          </v-button>
          <v-button
            size="xl"
            has-min-width
            @click="editProfile"
          >
            Edit Profile
          </v-button>
          <v-button
            size="xl"
            color="secondary"
            has-min-width
            @click="changePassword"
          >
            Change Password
          </v-button>
        </v-button-group>
        <br>
        <div
          v-if="isUserHasTARole()"
          class="warning-msg warning-local"
        >
          To Mark Profile up to date. Please confirm profile details and view and confirm competencies.
        </div>
      </div>
    </div>
    <div class="row">
      <div
        v-if="!isUserHasTARole()"
        class="row"
      >
        <div class="col-md-6 d-flex">
          <v-card title="Details">
            <v-definition-list
              :data="updateDetails"
            />
          </v-card>
        </div>
        <div class="col-md-6 d-flex">
          <v-card title="Address Details">
            <v-definition-list
              :data="updateBillingDetails"
            />
          </v-card>
        </div>
      </div>
      <div
        v-else
        class="row"
      >
        <v-profile-ta
          :current-user="currentUser"
          @viewedCompetencyPDF="(res)=>disableMarkProfileUptodate = false"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 d-flex">
        <strong>Notes:</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 d-flex">
        <ul>
          <li>The above email will be used as the primary contact for all NATA correspondence</li>
          <li>Above address details are for registration/identification purpose only, any changes made to the profile details will only appear on the profile once approved by NATA.</li>
          <li>
            To change the appointed Authorised Representative or Facility details please complete the <a
              href="https://www.nata.com.au/files/2021/05/Facility-Details-Update-Form-FDU.pdf"
              target="_blank"
              class="btn--secondary"
              download="Facility-Details-Update-Form-FDU.pdf"
            >Facility Details Update (FDU)</a> form and upload it on the Portal at the Site level or email us the form on <a
              :href="getEmail(true)"
              class="btn--secondary"
            >{{ getEmail() }}</a>.
          </li>
        </ul>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Card from "@/molecules/Card";
  import DefinitionList from "@/atoms/DefinitionList";
  import {buildBreadCrumb, buildDefinitionList} from "@/common/tableFunctions";
  import routes from "@/common/routes";
  import {mapState} from "vuex";
  // import Icon from "@/atoms/Icon";
  import ProfileTA from "./ProfileTA.vue";
  import constants from "@/common/constants";
  import ApiService from "@/common/apiService";

  export default {
    name: "Profile",
    components: {
      'v-button': Button,
      'v-button-group': ButtonGroup,
      'v-card': Card,
      "v-definition-list": DefinitionList,
      // "v-icon": Icon,
      "v-profile-ta": ProfileTA,
      PageTemplate
    },
    data: () => ({
      disableMarkProfileUptodate: true
    }),
    computed: {
      // currentUser: this.$store.getters.getUser;
        ...mapState({
          currentUser: state => state.auth.user,
        }),
        updateDetails: function() {
            let details  = [];
            let user = this.$store.getters.getUser;

            details['Name'] = user.first_name;
            details['Last Name'] = user.last_name;
            details['Email Address'] = user.email;
            details['Phone'] = user.mobile_number;
            return buildDefinitionList(details);

        },
        updateBillingDetails: function(){
            let billing_details = [];
            let user = this.$store.getters.getUser;
            billing_details['Address'] = user.address;
            billing_details['Suburb'] = user.suburb;
            billing_details['Country'] = user.country;
            billing_details['State'] = user.state;
            billing_details['Post Code'] = user.postcode;
            return buildDefinitionList(billing_details);
        }
      },
    mounted(){
      this.updateBreadCrumb();
    },
    methods:{
        updateBreadCrumb: function() {
            let breadcrumbs = [];
            breadcrumbs['Dashboard'] = routes.DASHBOARD;
            breadcrumbs['Profile'] = '';
            this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
        },
        changePassword:function () {
            this.$router.push(routes.CHANGE_PASSWORD)
        },
        editProfile: function(){
            this.$router.push(routes.EDIT_PROFILE)
        },
        getEmail(isLink) {
        if(isLink)
          return "mailto:"+constants.NATA_CONTACTS.EMAIL;
        return constants.NATA_CONTACTS.EMAIL;
      },
      isUserHasTARole() {
        let user = this.$store.getters.getUser;
        if(!user || !user.roles) {
          return false;
        }
        if(!this.currentUser) {
          this.currentUser = user;
        }
        return user.roles.filter(ele => {
                if(ele.id === constants.NATA_ROLE_TA_ID)
                  return true;
                return false;
              }).length > 0 && this.currentUser.user_info;

      },
      getTAPersonalDetails() {
        let details  = [];
        details['First Name'] = this.currentUser.first_name;
        details['Last Name'] = this.currentUser.last_name;
        return buildDefinitionList(details);
      },
      viewTACompetency() {
        ApiService.get("/activeuser/competencypdf")
                .then(response => {
                    if(response.data.data)
                      window.open(response.data.data, '_blank');
                    else
                      this.$notify({
                        title: 'Error',
                        text:'Competency PDF is not available yet. Please contact administrator.',
                        type: 'error'
                      });
                })
                .catch(error => {
                  this.$notify({
                      title: 'Error',
                      text:'Competency PDF is not available yet. Please contact administrator.',
                      type: 'error'
                    });
                });
      },
      getAddressTitle(item) {
        return item.Type + ' Address';
      },
      updateAddressDetails(item) {
        let billing_details = [];
        // let user = this.currentUser;
        billing_details['Address'] = item.AddressLine;
        billing_details['Suburb'] = item.Suburb;
        billing_details['Country'] = item.Country;
        billing_details['State'] = item.State;
        billing_details['Post Code'] = item.Postcode;
        return buildDefinitionList(billing_details);
      },
      markProfileUptodate() {
        ApiService.get("/activeuser/markprofileuptodate")
          .then(response => {
            if(response.data.data)
              this.$notify({
                  title: 'Success',
                  text: 'Successfully marked profile as up to date.',
                  type: 'success'
                });
            else
              this.$notify({
                  title: 'Error',
                  text:'Unable to mark profile as up to date. Please contact administrator.',
                  type: 'error'
                });
          })
          .catch(error => {
            this.$notify({
                title: 'Error',
                text:'Unable to mark profile as up to date. Please contact administrator.',
                type: 'error'
              });
          });
      },
      isCOmpetencyPDFUploaded() {
        return !(this.currentUser.user_info.competency_pdf_uri && this.currentUser.user_info.competency_pdf_uri.indexOf(this.currentUser.resource_id) !== -1);
      }
    }
  }
</script>
<style lang="scss">

  .selected-icon {
    font-size: 1.5em;
    color: #0076ff;
    display: flex;
  }
  .primaryTitle {
    display: flex;
    justify-content: center;
  }
  .address-primary {
    display: flex;
    justify-content: flex-end;
    color: #0076ff;;
    font-weight: bolder;
  }
  .gap-in-list {
    margin-bottom: 1rem;
  }
  .warning-local {
    display:flex;
    justify-content:flex-end;
    margin-top: -20px
  }
</style>

